<div class="container" *ngIf="init">
  <div class="pulse"></div>
  <!-- <span class="logo" [ngClass]="{'init':init}" [routerLink]="'/'">BrBa</span> -->
  <span *ngIf="!icy_metadata && !duration"> ... </span>
  <span *ngIf="icy_metadata && !title" class="player">
    <ng-container *ngIf="duration=='00:00'"></ng-container> <ng-container>{{icy_metadata}}</ng-container>
  </span>
  <span class="player" *ngIf="title">
    <ng-container *ngIf="duration=='00:00'"></ng-container> <ng-container>{{title}}</ng-container>
  </span>
  <!-- <span *ngIf="icy_metadata">
    <a (click)="mute()" [ngClass]="{'delete':delete}">mute</a>
  </span> -->
  <!-- <span *ngIf="icy_metadata && duration!='00:00'"><a (click)="play()" [ngClass]="{'play':isPlay}">pause</a></span> -->
  <!-- {{duration}} -->
  <span *ngIf="duration!='00:00' && currentTime"><a (click)="stop()" [ngClass]="{'play':isStop}">stop</a></span>
  <span *ngIf="currentTime && duration!='00:00'">{{currentTime}}<ng-container *ngIf="duration!='00:00'">/{{duration}}</ng-container></span>
</div>

<!--  -->
